export const GeneralModuleTranslations: Array<string> = [

    // title
    'xmlCountries',

    // Countries/Regions list
    'Admin.vcountry_list.Title',
    'Admin.CountriesDataTable.QuickSearch',
    'Admin.vcountry_list.TViewColCountryName',
    'Admin.vcountry_list.TViewColCountryAbrev2',
    'Admin.vcountry_list.TViewColCountryAbrev3',
    'Admin.CountryList.AddNewCountry',
    'Admin.CountryList.DuplicateAbrev2Tooltip',
    'Admin.TablesLanguageSelector.Hint',

    // Countries/Regions add/edit
    'Admin.addEditCountry.Title',
    'Admin.addEditCountry.LabelCountryName',
    'Admin.addEditCountry.JSMSGCountryNameTooLong',
    'Admin.addEditCountry.JSMSGCountryNameMissing',
    'Admin.addEditCountry.LabelCountryAbrev2',
    'Admin.addEditCountry.JSMSGCountryAbrev2Missing',
    'Country.CountryAbbrev2.DigitsForbidden',
    'Admin.addEditCountry.LabelCountryAbrev3',
    'Admin.addEditCountry.JSMSGCountryAbrev3Missing',
    'Country.CountryAbbrev3.DigitsForbidden',

    // Countries/Regions language translation
    'Admin.CountryTranslation.Title',
    'Admin.CountryTranslation.Column.Label',
    'Admin.CountryTranslation.Column.DefaultLanguage',
    'Admin.CountryTranslation.CountryInfo',
    'Admin.CountryTranslation.CountryInfo.Name',
    'Admin.CountryTranslation.SelectLanguage',

    // States list
    'Admin.StatesDataTable.QuickSearch',
    'Admin.StatesDataTable.QuickSearch',
    'Admin.StatesDataTable.Name', 'Name',
    'Admin.StatesDataTable.Abbreviation',
    'Admin.StatesDataTable.CountryRegion',
    'Admin.StatesDataTable.AddNew',


    // States add/edit
    'Admin.StateList.AddNewState',
    'Admin.addEditState.LabelStateName',
    'Admin.addEditState.LabelStateAbbreviation',
    'Admin.addEditState.LabelCountry',
    'Admin.addEditState.StatesTitle',
    'xmlStates',

    //File Management
    'xmlFileManagement',
    'Admin.FileManagement.CategoryImages',
    'Admin.FileManagement.AttributeImages',
    'Admin.FileManagement.Actions',
    'Admin.FileManagement.AdditionalFiles',
    'Admin.FileManagement.CompanyLogos',
    'Admin.FileManagement.Fonts',
    'xmlTopMenu',
    'Admin.FileManagement.ProductImages',
    'Admin.FileManagement.NewFolder',
    'Admin.FileManagement.QuickFilter',
    'Admin.FileManagement.DeleteWarning',
    'Admin.FileManagement.DeleteFileMsg',
    'Admin.FileManagement.DeleteFolderMsg',

    //Territories add/edit
    'xmlTerritories',
    'AddEditTerritory.Title',
    'Admin.territory_list.TViewColTerritoryName',
    'Admin.territory_list.TViewColTerritoryDescription',
    'Admin.territory_list.TViewColTerritoryIsActive',
    'Admin.add_edit_territory.LabelTerriotryName',
    'Admin.add_edit_territory.LabelTerriotryIsActive',
    'Admin.add_edit_territory.LabelTerriotryDescription',
    'Admin.territory_list.Title',
    'Admin.territory_list.QuickSearch',

    //Email settings
    'xmlEmailSettings',
    'Admin.EmailSettings.SettingsType.Users',
    'Admin.EmailSettings.SettingsType.DocumentGeneration',
    'Admin.EmailSettings.SmtpType.SapSmtpService',
    'Admin.EmailSettings.SmtpType.CustomSmtpService',
    'Admin.EmailSettings.SmtpType.CpqLegacyService',
    'Admin.EmailSettings.SmtpAuthenticationType.None',
    'Admin.EmailSettings.SmtpAuthenticationType.UsernameAndPassword',
    'Admin.EmailSettings.EmailAddressSourceType.None',
    'Admin.EmailSettings.EmailAddressSourceType.CurrentUserEmail',
    'Admin.EmailSettings.EmailAddressSourceType.CustomEmail',
    'Admin.EmailSettings.DisplayNameSourceType.None',
    'Admin.EmailSettings.DisplayNameSourceType.CurrentUserFullName',
    'Admin.EmailSettings.DisplayNameSourceType.CustomName',
    'Admin.EmailSettings.DefaultEmailSettings',
    'Admin.EmailSettings.DefaultEmailSettings',
    'Admin.EmailSettings.QuickFilterPlaceholder',
    'Admin.EmailSettings.SettingsType',
    'Admin.EmailSettings.SmtpType',
    'Admin.EmailSettings.SmtpSettings',
    'Admin.EmailSettings.SmtpAddress',
    'Admin.EmailSettings.EnableSmtpPort',
    'Admin.EmailSettings.SmtpPort',
    'Admin.EmailSettings.SmtpAuthenticationType',
    'Admin.EmailSettings.SmtpUsername',
    'Admin.EmailSettings.SmtpPassword',
    'Admin.EmailSettings.AffectedFeatures',
    'Admin.EmailSettings.EmailProperties',
    'Admin.EmailSettings.FromEmailSource',
    'Admin.EmailSettings.FromEmailAddress',
    'Admin.EmailSettings.FromDisplayNameSource',
    'Admin.EmailSettings.FromDisplayName',
    'Admin.EmailSettings.SenderEmailSource',
    'Admin.EmailSettings.SenderEmailAddress',
    'Admin.EmailSettings.SenderDisplayNameSource',
    'Admin.EmailSettings.SenderDisplayName',
    'Admin.EmailSettings.ReplyToEmailSource',
    'Admin.EmailSettings.ReplyToEmailAddress',
    'Admin.EmailSettings.ReplyToDisplayNameSource',
    'Admin.EmailSettings.ReplyToDisplayName',
    'Admin.DefaultEmailSettings.CpqLegacySmtpAddress',
    'Admin.EmailSettings.UserSettingsType.UserAdministration',
    'Admin.EmailSettings.UserSettingsType.UnlockUserAccount',
    'Admin.EmailSettings.UserSettingsType.UserSelfRegistration',
    'Admin.EmailSettings.UserSettingsType.ForgotPassword',
    'Admin.EmailSettings.DocumentGenerationSettingsType.SendingMails',
    'Admin.EmailSettings.SettingsType.AdminNotifications',
    'Admin.EmailSettings.AdminNotificationsSettingsType.BulkImportExport',
    'Admin.EmailSettings.AdminNotificationsSettingsType.KbSync',
    'Admin.EmailSettings.SettingsType.WorkflowNotifications',
    'Admin.EmailSettings.WorkflowNotificationsSettingsType.SendingMails',
    'Admin.EmailSettings.SettingsType.ApprovalAutoReminder',
    'Admin.EmailSettings.ApprovalAutoReminderSettingsType.SendingMails',
    'Admin.EmailSettings.SettingsType.QuoteExpiration',
    'Admin.EmailSettings.QuoteExpirationSettingsType.SendingMails',
    'Admin.EmailSettings.SettingsType.DocuSign',
    'Admin.EmailSettings.DocuSignSettingsType.SendingMails',
    'Admin.EmailSettings.ResetToDefaultSettings',
    'Admin.EmailSettings.Test',
    'Admin.EmailSettings.TestEmailNotification.Title',
    'Admin.EmailSettings.TestEmailNotification.Message',
    'Admin.EmailSettings.TestEmailNotification.AdditionalMessage',
    'Admin.EmailSettings.AvailablePorts.Other',
    'Admin.EmailSettings.OtherSmtpPort',
    'Admin.EmailSettings.CpqLegacySmtp.WarningMessage',
    'Admin.EmailSettings.SmtpOAuthProviderType',
    'Admin.EmailSettings.OAuthAccessTokenEndpoint',
    'Admin.EmailSettings.OAuthClientId',
    'Admin.EmailSettings.OAuthClientSecret',
    'Admin.EmailSettings.OAuthScopes',
    'Admin.EmailSettings.SmtpAuthenticationType.OAuth',

    //Report Module
    'xmlReportModuleNew',
    'xmlReportModuleDatasource',
    'xmlReportModuleReports',
    'xmlReportModuleStatuses',

    // Datatable
    'Admin.DatasourceDataTable.AddNew',
    'Admin.DatasourceDataTable.Name',
    'Admin.DatasourceDataTable.Description',
    'Admin.DatasourceDataTable.QuickSearch',

    //AddEdit Datasource
    'Admin.Msg.EditTitle',
    'Admin.DatasourceAddEdit.Name',
    'Admin.DatasourceAddEdit.Description',
    'Admin.DatasourceAddEdit.Query',

    // Report Definition Datatable
    'Admin.ReportDefinitionDataTable.AddNew',
    'Admin.ReportDefinitionDataTable.Name',
    'Admin.ReportDefinitionDataTable.Description',
    'Admin.ReportDefinitionDataTable.Labels',
    'Admin.ReportDefinitionDataTable.CreatedBy',
    'Admin.ReportDefinitionDataTable.QuickSearch',
    'Admin.ReportDefinitionDataTable.Preview',
    'Admin.ReportDefinitionDataTable.RunReport',
    'Admin.ReportDefinitionDataTable.ParametersDialog.YesMsg',
    'Admin.ReportDefinitionDataTable.ParametersDialog.Title',


    //AddEdit ReportDefinition
    'Admin.ReportDefinitionDataTable.AddNew',
    'Admin.ReportModule.AddEditReportDefinition.MainDetails.Step1',
    'Admin.ReportModule.AddEditReportDefinition.Name',
    'Admin.ReportModule.AddEditReportDefinition.Datasource',
    'Admin.ReportModule.AddEditReportDefinition.Description',
    'Admin.ReportModule.AddEditReportDefinition.Labels',
    'Admin.ReportModule.AddEditReportDefinition.ColumnSelection.Step2',
    'Admin.ReportModule.AddEditReportDefinition.Columns',
    'Admin.ReportModule.AddEditReportDefinition.Description.SelectedColumnHint',
    'Admin.ReportModule.AddEditReportDefinition.SelectColumns',
    'Admin.ReportModule.AddEditReportDefinition.DatasourceIsNotSelected',
    'Admin.ReportModule.AddEditReportDefinition.Permissions.Step5',
    'Admin.deflusersetup.PlaceholderForSelectUser',
    'Admin.ReportModule.AddEditReportDefinition.Permissions.VisibleToEveryone',
    'Admin.ReportModule.AddEditReportDefinition.OrderingColumns.Step4',
    'Admin.ReportModule.AddEditReportDefinition.OrderingColumns.AddNewInfoIcon',
    'Admin.ReportModule.AddEditReportDefinition.OrderingColumns.AvailableFields',
    'Admin.ReportModule.AddEditReportDefinition.OrderingColumns.OrderType',
    'Admin.ReportModule.AddEditReportDefinition.OrderingColumns.AscOrderType',
    'Admin.ReportModule.AddEditReportDefinition.OrderingColumns.DescOrderType',
    'Admin.ReportModule.AddEditReportDefinition.OrderingColumns.SortAvailableFields',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.Step3',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.LogicalOperator',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.AddCondition',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.AddGroup',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.Column',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.Operator',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.FilterType',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.ParameterName',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.DisablingInfo',
    'Admin.ReportModule.AddEditReportDefinition.FilterCriteria.Value',
    'Admin.ReportModule.AddEditReportDefinition.Permissions.Step6',
    'Admin.ReportModule.AddEditReportDefinition.Permissions.Step6.Preview',
    'Admin.ReportModule.AddEditReportDefinition.Permissions.Preview.Warning'
];
